module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h1', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00000"
    }
  }, [_vm._v(" ON THE PAMPAS")]), _vm._v(" "), _c('h2', {
    staticClass: "c2 sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00001"
    }
  }, [_vm._v("THE YOUNG SETTLERS")]), _vm._v(" "), _c('p', [_c('br')]), _vm._v(" "), _c('h5', {
    staticClass: "sigil_not_in_toc"
  }, [_vm._v("BY")]), _vm._v(" "), _c('h3', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00002"
    }
  }, [_vm._v("G. A. HENTY")]), _vm._v(" "), _c('div', {
    staticClass: "center smfont"
  }, [_vm._v("\n    AUTHOR OF ‘THE YOUNG FRANC-TIREURS,’ ‘THE YOUNG BUGLERS,’"), _c('br'), _vm._v("\n    ‘THE MARCH TO MAGDALA,’ ETC. ETC."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n    WITH ILLUSTRATIONS BY J. B. ZWECKER."), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "figcenter"
  }, [_c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "G F",
      "height": "57",
      "src": "Images/002.jpg",
      "title": "",
      "width": "75"
    }
  }), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('b', [_vm._v("LONDON")]), _c('br'), _vm._v("\n  GRIFFITH  FARRAN  &  CO."), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "smfont"
  }, [_vm._v("NEWBERY HOUSE, 39 CHARING CROSS ROAD")]), _c('br')]), _vm._v(" "), _c('p', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center smfont"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d57e1f9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/main_0001_0001.vue
// module id = 60
// module chunks = 0